module.exports = __webpack_public_path__ + "img/top_img_bg.b4db8416.png";